<app-header class="app-header-fixed"></app-header>
<app-sidebar></app-sidebar>
<main class="app-content">
  <router-outlet></router-outlet>
</main>
